/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

import { CssBaseline, ThemeProvider } from '@mui/material'
import { QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import App from 'App'
import theme from 'assets/theme'
import themeDark from 'assets/theme-dark'
import queryClient from 'config/reactQueryClient'
import { AuthProvider } from 'context/auth'
import { MaterialUIControllerProvider, useMaterialUIController } from 'context/materialUI'

// Create a wrapper that applies the current theme from context
function ThemedAppWrapper() {
	const [controller] = useMaterialUIController()
	const { darkMode } = controller

	return (
		<ThemeProvider theme={darkMode ? themeDark : theme}>
			<CssBaseline />
			<AuthProvider>
				<App />
			</AuthProvider>
		</ThemeProvider>
	)
}

ReactDOM.render(
	<BrowserRouter>
		<QueryClientProvider client={queryClient}>
			<MaterialUIControllerProvider>
				<ThemedAppWrapper />
			</MaterialUIControllerProvider>
		</QueryClientProvider>
	</BrowserRouter>,
	document.getElementById('root')
)
